import { useGlobalState } from '../../../state/persistence';

const FORMULAS: { [k: number]: Array<number> } = {
  0: [44.683, -0.664],
  1: [31.366, -0.585],
  2: [93.947, -0.838],
  3: [72.438, -0.673],
  4: [70.522, -0.655],
  5: [34.101, -0.496],
  6: [77.429, -0.772],
  7: [85.262, -0.715],
  8: [73.546, -0.668],
  9: [123.07, -0.806],
};

const calculatePreResult = (postalCode = '00000', apartmentSize = 25): number => {
  const [factor, exponent] = FORMULAS[Number(postalCode[0])];
  return Math.round(factor * apartmentSize ** exponent * apartmentSize);
};

const useCalculatePreResult = (): number => {
  const { question } = useGlobalState();
  return calculatePreResult(question.postcode, question.apartmentSize);
};

export default useCalculatePreResult;
